// Display-label translation for the user's role. The backend stores role
// names as the seeded canonical strings ("Tenant Admin", "Sub Admin",
// "Editor", "Viewer", "SuperAdmin", "PlatformSupport") plus any custom
// names a Tenant Admin creates from the UI. Product copy never shows
// "Tenant" as a prefix -- it would expose the platform/tenant model to
// end users -- so we map:
//
//   * Platform SuperAdmin shortcut    -> "Super Admin"
//   * Stored role "Tenant Admin"      -> "Super Admin" (top-of-tenant)
//   * Any other stored role           -> show as-is (covers Sub Admin,
//                                       Editor, Viewer, and tenant-defined
//                                       custom roles where the Tenant
//                                       Admin already picked a
//                                       customer-facing name)
//   * null role + non-SuperAdmin user -> "User" (fallback for fresh signups
//                                       and Individual onboarding users
//                                       who don't have a membership yet)
//
// The translation is intentionally CLIENT-SIDE. The backend stays neutral
// about product copy; if marketing renames "Super Admin" to "Tenant Owner"
// next quarter, we change this one function rather than data-migrate.
export interface RoleSource {
  roleName: string | null;
  isSuperAdmin: boolean;
}

export function roleDisplayLabel(source: RoleSource): string {
  if (source.isSuperAdmin) {
    return 'Super Admin';
  }

  if (!source.roleName) {
    return 'User';
  }

  if (source.roleName === 'Tenant Admin') {
    return 'Super Admin';
  }

  return source.roleName;
}
